import { Check } from "lucide-react";

type Props = {
  disabled?: boolean;
  onAccept: () => void;
};

export function MatchSuggestionButton({ disabled, onAccept }: Props) {
  return (
    <button
      type="button"
      onClick={onAccept}
      disabled={disabled}
      title="Accept AI-suggested match"
      className="inline-flex h-5 w-5 items-center justify-center rounded-full border border-emerald-300 bg-emerald-50 text-emerald-600 hover:bg-emerald-100 disabled:cursor-not-allowed"
    >
      <Check className="h-3 w-3" strokeWidth={3} aria-hidden />
    </button>
  );
}

